import { ApiService } from '../../theme/utils/api.service';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { NoInternetHelper } from '../../theme/utils/no-internet-helper';

@Injectable({ providedIn: 'root' })
export class HonoraireService {
  honoraire: any;
  public edit: boolean = false;
  private url = 'private/trustee/honoraire';

  constructor(private api: ApiService) {}

  setHonoraire(data: any) { this.honoraire = data; }
  getHonoraire(): any { return this.honoraire; }

  add(data: any): Observable<any> {
    if (!navigator.onLine) { NoInternetHelper.internet(); return Observable.create(obs => { obs.next(); obs.complete(); }); }
    return data.uuid ? this.update(data) : this.create(data);
  }

  create(data: any): Observable<any> {
    return this.api._post(`${this.url}/new`, data).pipe(map((r: any) => r), catchError((e: any) => throwError(e)));
  }

  update(data: any): Observable<any> {
    return this.api._post(`${this.url}/${data?.uuid}/edit`, data).pipe(map((r: any) => r), catchError((e: any) => throwError(e)));
  }

  getList(trustee?: string): Observable<any[]> {
    if (!navigator.onLine) { NoInternetHelper.internet(); return Observable.create(obs => { obs.next(); obs.complete(); }); }
    return this.api._get(`${this.url}`, { trustee }).pipe(map((r: any) => r), catchError((e: any) => throwError(e)));
  }

  getSingle(uuid: string): Observable<any> {
    if (!navigator.onLine) { NoInternetHelper.internet(); return Observable.create(obs => { obs.next(); obs.complete(); }); }
    return this.api._get(`${this.url}/${uuid}/show`).pipe(map((r: any) => r.data), catchError((e: any) => throwError(e)));
  }

  getDelete(uuid: string): Observable<any> {
    if (!navigator.onLine) { NoInternetHelper.internet(); return Observable.create(obs => { obs.next(); obs.complete(); }); }
    return this.api._delete(`${this.url}/${uuid}/delete`).pipe(map((r: any) => r), catchError((e: any) => throwError(e)));
  }
}
